import React from 'react';
import { IExperiment } from '../../apiHooks/experimentApi.types';
import { Link } from 'gatsby';
import { getResultStateFromExperiment } from '../../apiHooks/utils';
import ExperimentListItemContent from './ExperimentListItemContent';
import { clsx } from 'clsx';

interface IProps {
    experiment: IExperiment | null;
    asLink?: boolean;
    variant?: 'focus' | 'hover';
}

export default function ExperimentListItemSlim(props: IProps) {
    const { experiment, asLink = true, variant = 'hover' } = props;

    if (!experiment) {
        return (
            <div
                className={clsx(
                    'h-16 flex items-center border-b border-gray-100 animate-pulse',
                    asLink ? 'px-6' : 'px-3',
                )}
            >
                <div className='flex-shrink-0 mr-3'>
                    <div className='flex-none rounded-full p-1 bg-gray-200'>
                        <div className='h-2 w-2 rounded-full bg-gray-300' />
                    </div>
                </div>
                <div className='flex-1 min-w-0 flex flex-col justify-center'>
                    <div className='h-4 bg-gray-200 rounded w-3/4 mb-2' />
                    <div className='flex items-end mb-0.5 '>
                        <div className='h-3.5 bg-gray-100 rounded w-1/2 flex-1' />
                        <div className='h-3 w-20 bg-gray-100 rounded ml-3 self-end' />
                    </div>
                </div>
            </div>
        );
    }

    const lastCreatedResult = experiment.last_created_result;

    const to = experiment.uuid
        ? `/experiments/${experiment.uuid}/results/${lastCreatedResult.uuid}/`
        : `/results/${lastCreatedResult.uuid}/`;

    const state = getResultStateFromExperiment(experiment);

    if (!asLink) {
        return (
            <div className='h-16 flex items-center px-3 border-b border-gray-100'>
                <ExperimentListItemContent experiment={experiment} variant={variant} />
            </div>
        );
    }

    return (
        <Link
            to={to}
            className='group h-16 flex items-center hover:bg-gray-100 hover:no-underline cursor-pointer px-6 border-b border-gray-100'
            title={`${state[0].toUpperCase()}${state.slice(1)}`}
        >
            <ExperimentListItemContent experiment={experiment} variant={variant} />
        </Link>
    );
}
